import { Form, Input, Grid, Select, Field, Button, Icon, Table, Pagination, Tab, Upload, Dialog, Balloon, DatePicker } from "@alifd/next";
import { BefGlobalContext, BefMessageButtonType, BefMessageServiceContext, BefMessageType, BefPageContainerServiceContext, BefPageServiceContext } from "@beflam/bef-core";
import axios from "axios";
import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { MixIcon } from "../MixIcon";
import { ObjectFile, UploadFile } from "@alifd/next/types/upload/types";
import { Base64 } from 'js-base64';
import { saveAs } from "file-saver";
const regexp = new RegExp(/^[a-zA-Z][0-9a-zA-Z_]{0,49}$/);
const Tooltip = Balloon.Tooltip;
const DataSetManager = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, datas, type, typeId, changeEvent, ...otherProps } = props;
    let [dataSource, setDataSource] = useState({
        data: [] as any[], dataSource: [] as any[], currentPage: 1, selectedRowKeys: [], selectRecords: [] as any[], columnWidth: {
            ChunkMethod: 150,
            CreateDate: 150,
            Id: 200,
            Location: 200,
            Name: 200,
            ProcessDuation: 100,
            Progress: 100,
            ProgressMsg: 200,
            Run: 100,
            Status: 100,
            Type: 100,
            UpdateDate: 150,
            chunk_count: 100
        } as any
    });
    let [visible, setVisible] = useState({ upload: false, uploadImg: false, imgEdit: false });
    const setVisibleEx = (data: any) => {
        visible = data;
        setVisible(data);
    }
    const [uploadValues, setUploadValues] = useState<any>([]);
    const pageService = useContext(BefPageServiceContext);
    const sGlobal = useContext(BefGlobalContext);
    const messageService = useContext(BefMessageServiceContext);
    const pageSize = 10;
    let contextComp: any = {};
    const [dataSource1, setDataSource1] = useState({});
    const [divHeight, setDivHeight] = useState<any>(0);
    const perRef = useRef(null);
    contextComp.setState = (data: any) => {
        setDataSource1(data);
    }
    const fieldRef = useRef(new Field(contextComp));
    const [currentTab, setCurrenttab] = useState<any>(1);
    const [uploadUrl, SetUploadUrl] = useState("");
    const [header, setHeader] = useState<any>();

    let [imgDataSource, setImgDataSource] = useState({
        data: [] as any[], dataSource: [] as any[], currentPage: 1, selectedRowKeys: [], selectRecords: []

    });
    const imgPageSize = 8;
    const fileRef = useRef<any>();
    const [uploadImgUrl, SetUploadImgUrl] = useState("");
    const [exStr, setExStr] = useState<any>({});
    const [imgUploadValues, setImgUploadValues] = useState<any>([]);
    const [imgDescData, setImgDescData] = useState<any>({ id: '', chunkId: '', content: '' });
    const previewHost = sGlobal?.extend?.KKFileView?.Host;
    let imgDataSetIdRef = useRef<any>();
    const refresh = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            const response = await axios.get(
                sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/documents?type=${type}&typeid=${typeId}`,
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            );
            if (response.data.code !== 0 && response.data.code !== '0') {
                throw JSON.stringify(response.data);
            }
            else {
                let data = [] as any;
                if (response.data.Data)
                    data = response.data.Data
                dataSource.data = data;
                setDataSourceEx({ ...dataSource, data: data, selectedRowKeys: [], selectRecords: [] });
                onPaginationChange(dataSource.currentPage);
                SetUploadUrl(sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/documents?chunkingmethod=naive&type=${type}&typeid=${typeId}`)

                setHeader({ 'Authorization': `Bearer ${sGlobal.session.id}` });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "知识库列表获取"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const setDataSourceEx = (data: any) => {
        dataSource = data;
        setDataSource(data);
    }
    const onPaginationChange = (current: number, e?: any) => {
        let result = dataSource.data.slice((current - 1) * pageSize, current * pageSize);
        if (result.length > 0) {
            setDataSourceEx({ ...dataSource, dataSource: result, currentPage: current });
        } else {
            if (current !== 1) {
                current = current - 1;
                let _result = dataSource.data.slice((current - 1) * pageSize, current * pageSize);
                setDataSourceEx({ ...dataSource, dataSource: _result, currentPage: current });
            } else {
                setDataSourceEx({ ...dataSource, dataSource: result, currentPage: 1 });
            }
        }

    }
    const actionCellRender = (value: any, index: number, record: any) => {
        // let text = "";
        // if (record.Run === "0") {
        //     text = "处理";
        // }
        // else if (record.Run === "1")
        //     text = "停止处理";
        // else if (record.Run === "2")
        //     text = "重新处理";
        // else
        //     text = record.Run;

        return <>
            <Button style={{ marginRight: 12 }} onClick={() => userGroupClick(value, record, { id: 'preview' })}> 预览</Button>
            <Button style={{ marginRight: 12 }} onClick={() => userGroupClick(value, record, { id: 'delete' })}> 删除</Button>
            <Button style={{ marginRight: 12 }} onClick={() => userGroupClick(value, record, { id: 'analysis' })}> 解析</Button>
            <Button style={{ marginRight: 12 }} onClick={() => userGroupClick(value, record, { id: 'download' })}> 下载</Button>
            {/* <Button onClick={() => userGroupClick(value, record, { id: 'handle' })}> {text}</Button> */}
        </>;
    };
    const userGroupClick = (value: any, record: any, args: any) => {
        switch (args.id) {
            case 'analysis': {
                //暂无
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                analysisData();
                break;
            }
            case 'delete': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                deleteData();
                break;
            }
            case 'handle': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                handleData();
                break;
            }
            case 'preview': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                preView();
                break;
            }
            case 'download': {
                setDataSourceEx({ ...dataSource, selectedRowKeys: [value], selectRecords: [record] });
                downloadData();
                break;
            }
        }
    }
    const preView = async () => {
        try {

            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0 || dataSource.selectedRowKeys.length > 1) throw new Error("请选择一条数据");
            let recode = dataSource.selectRecords[0];
            let _host = sGlobal.config.host ? sGlobal.config.host : window.location.origin;
            const url = `${_host}/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/documents/${recode.Id}?session_id=${sGlobal.session.id}&fullfilename=${recode.Name}`;
            window.open(`${previewHost}/onlinePreview?url=${encodeURIComponent(Base64.encode(url))}`);
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "预览文档"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const downloadData = async () => {
        try {
            if (dataSource.selectRecords == null || dataSource.selectRecords.length === 0) throw new Error("请选择一条数据");
            const record = dataSource.selectRecords[0];
            let _host = sGlobal.config.host ? sGlobal.config.host : window.location.origin;
            const url = `${_host}/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/documents/${record.Id}?session_id=${sGlobal.session.id}`;
            const response = await axios.get(url, {
                headers: { 'Authorization': `Bearer ${sGlobal.session.id}` },
                responseType: 'blob',
            });
            const blob = new Blob([response.data], { type: response.headers["content-type"]?.toString() });
            saveAs(blob, record.Name || 'download');
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "下载文档"));
        }
    }
    const analysisData = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0) throw new Error("请选择至少一条数据");
            const ids = dataSource.selectRecords.map((val) => val.Id).join(",");
            const data = dataSource.selectRecords.map((val) => val.Id);
            const dataset = fieldRef.current.getValues();
            await axios.post(sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${dataset.Id}/chunks?type=${type}&typeid=${typeId}`, data, { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }).then(response => {
                if (response.data.code.toString() === '0') {
                    messageService.showMessage({ mes: `解析<${ids}>成功` });
                    refresh();
                }
                else {
                    throw JSON.stringify(response.data);
                }

            }).catch(error => {
                throw error;
            });
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "解析知识库"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const deleteData = async (deleteId = null) => {
        try {
            let ids = "";
            let data = [];
            if (!deleteId) {
                if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0) throw new Error("请选择至少一条数据");
                ids = dataSource.selectRecords.map((val) => val.Id).join(",");
                data = dataSource.selectRecords.map((val) => val.Id);
            } else {
                ids = deleteId;
                data = [deleteId];
            }
            let messageResult = await messageService.showMessage({ mes: `是否确定删除Id：<${ids}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                sGlobal.showloading = true;
                sGlobal.showLoadingEvent.emit();
                const response = await axios.delete(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/documents?type=${type}&typeid=${typeId}`,
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` }, data: data },

                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        messageService.showMessage({ mes: `删除<${ids}>成功` });
                        if (deleteId) getImgList();
                        refresh();
                    }
                    else {
                        throw JSON.stringify(response.data);
                    }
                }).catch(error => {
                    throw error;
                });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除文档"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const handleData = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            if (dataSource.selectedRowKeys == null || dataSource.selectedRowKeys.length === 0) throw new Error("请选择至少一条数据");
            const ids = dataSource.selectRecords.map((val) => val.Id).join(",");
            const data = dataSource.selectRecords.map((val) => val.Id);
            // let messageResult = await messageService.showMessage({ mes: `是否确定删除Id：<${ids}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (dataSource.selectRecords[0].Run === "0") {
                axios.post(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/chunks?type=${type}&typeid=${typeId}`,
                    data,
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } },
                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        messageService.showMessage({ mes: `处理<${ids}>成功` });
                        refresh();
                    }
                    else {
                        messageService.showMessage(messageService.handleErr(JSON.stringify(response.data), "处理出错"));
                    }
                }).catch(error => {
                    throw error;
                });
            }
            else if (dataSource.selectRecords[0].Run === "1") {
                axios.delete(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/chunks?type=${type}&typeid=${typeId}`,
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}`, data: data } },
                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        messageService.showMessage({ mes: `停止处理<${ids}>成功` });
                        refresh();
                    }
                    else {
                        messageService.showMessage(messageService.handleErr(JSON.stringify(response.data), "停止处理出错"));
                    }
                }).catch(error => {
                    throw error;
                });
            }
            else if (dataSource.selectRecords[0].Run === "2") {
                axios.post(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/chunks?type=${type}&typeid=${typeId}`,
                    { data: data },
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        messageService.showMessage({ mes: `重新处理<${ids}>成功` });
                        refresh();
                    } else {
                        messageService.showMessage(messageService.handleErr(JSON.stringify(response.data), "重新处理出错"));
                    }
                }).catch(error => {
                    throw error;
                });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除知识库"));
        }
        finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const changeStatus = (value: any, index: any, record: any) => {
        if (value === "0") return "PENDING";
        if (value === "1") return "RUNNING";
        if (value === "2") return "SUCCESS";
    }
    const runStatus = (value: any, index: any, record: any) => {
        let text = "";
        switch (value) {
            case 'RUNNING':
                text = '解析中';
                break;
            case 'CANCEL':
                text = '取消';
                break;
            case 'DONE':
                text = '完成';
                break;
            case 'UNSTART':
                text = '初始状态';
                break;
            case 'FAIL':
                text = '失败';
                break;
        }
        const intro = (
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {value}
            </div>
        );
        return (
            <Tooltip v2 trigger={intro} align="br" arrowPointToCenter>
                {record.ProgressMsg}
            </Tooltip>
        );

    }
    const onSave = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            if (!fieldRef || !fieldRef.current) throw new Error("fieldRef is null");
            let data = fieldRef.current.getValues();
            const response = await axios.put(
                sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets?type=${type}&typeid=${typeId}`,
                { Id: data.Id, Description: data.Description },
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            ).then(response => {
                if (response.data.code.toString() === '0') {
                    messageService.showMessage({ mes: `修改<${data.Name}>成功` });
                }
                else {
                    throw JSON.stringify(response.data);
                }
            }).catch(error => {
                throw error;
            });

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "知识库修改"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    //删除知识库
    const onDelete = async () => {
        try {

            if (!fieldRef || !fieldRef.current) throw new Error("fieldRef is null");
            let result: any = fieldRef.current.getValues();
            const ids = result.Id;
            const data = [result.Id];
            let messageResult = await messageService.showMessage({ mes: `是否确定删除Id：<${ids}>？`, type: BefMessageType.communication, btntype: BefMessageButtonType.YesAndNo });
            if (messageResult === 1) {
                sGlobal.showloading = true;
                sGlobal.showLoadingEvent.emit();
                const response = await axios.delete(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets?type=${type}&typeid=${typeId}`,
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` }, data: data },
                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        messageService.showMessage({ mes: `删除<${ids}>成功` });
                        //pageService.close();
                        if (changeEvent) {
                            changeEvent(true);
                        }
                    } else
                        throw JSON.stringify(response.data);
                }).catch(error => {
                    throw error;
                });
            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "删除知识库"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const onUploadChange = (items: any) => {
        let temp = items.map((info: any) => {
            if (info.state == "error") {
                info.errorMsg = info.error?.message;
            }
            return info;
        });
        setUploadValues(temp);
    };

    const onUploadSuccess = (file: ObjectFile, value?: ObjectFile[]) => {
    };
    const formatRes = (response: any, file: any) => {
        return {
            success: response.code == 0,
            message: response.code == 0 ? "上传成功" : response.message,
        };
    }
    const onUploadError = (file: any, value: any) => {
        // var msg = JSON.stringify(value);
        // messageService.showMessage(messageService.handleErr(value, `上传失败:${msg}`));
    }
    const onOK = () => {
        setVisibleEx({ ...visible, upload: false });
        if (uploadValues && uploadValues.length > 0) {
            refresh();
        }

    }
    const exdata = (file: UploadFile) => {
        let _content = "";
        if (file.uid && exStr[file.uid]) _content = exStr[file.uid];
        return { content: _content };
    }
    const beforeImgUpload = (file: UploadFile) => {

        return new Promise<void>((resolve, reject) => {
            if (!file.type.startsWith('image/')) {
                reject({ message: "不是有效图片格式" }); // 不是图片类型
            } else {

                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => resolve(); // 图片加载成功，认为是有效的图片文件
                    img.onerror = () => {
                        reject({ message: "图片加载失败，可能文件损坏或不是有效图片格式" });
                    } // 图片加载失败，可能文件损坏或不是有效图片格式
                    img.src = reader.result as string;
                };
                reader.onerror = (error) => {
                    reject({ message: "文件读取错误" });
                } // 文件读取错误
                reader.readAsDataURL(file)


            }
        });
    }
    const imgUploadOk = () => {
        if (fileRef && fileRef.current) {
            fileRef.current?.getInstance()?.startUpload();
        }
        // if (folderRef && folderRef.current) {
        //     folderRef.current?.getInstance()?.startUpload();
        // }
    }
    const onImgUploadChange = async (items: any) => {
        let temp = [];
        for (let info of items) {
            if (info.state == "error") {
                info.errorMsg = info.error?.message;
            }
            else {
                if (!info.url) {
                    info.url = await fileToDataURLSync(info.originFileObj);
                }

            }
            temp.push(info)
        }
        setImgUploadValues(temp);
    };
    const actionRender = (file: ObjectFile) => {
        let disable = false;
        if (file.state == "done")
            disable = true;
        let _default = "";
        if (file.uid && exStr[file.uid])
            _default = exStr[file.uid];
        return <div style={{ display: 'flex', gap: '8px', width: '300px', height: '48px' }}>
            <label>描述</label>
            <Input.TextArea rows={2} style={{ flex: 1, fontSize: '14px' }} disabled={disable}
                defaultValue={_default}
                onChange={(val => {
                    if (file.uid) {
                        exStr[file!.uid] = val;
                        setExStr(exStr);
                    }
                })} />
            <button style={{ background: 'none', border: 'none' }} onClick={() => {
                let _val = imgUploadValues.filter((item: any) => item.uid != file.uid);
                setImgUploadValues(_val);
            }}>
                <Icon type="close" />
            </button>
        </div>
    }
    function fileToDataURLSync(file: any) {
        let res = new Promise<any>((resolve, reject) => {
            if (!file.type.startsWith('image/')) {
                resolve(-1); // 不是图片类型
            } else {

                const reader = new FileReader();
                reader.onload = (e) => {
                    resolve(reader.result);
                };
                reader.onerror = (error) => {
                    resolve(-1);
                } // 文件读取错误
                reader.readAsDataURL(file)


            }
        });
        return res;
    }
    //imgdata
    const setImgDataSourceEx = (data: any) => {
        imgDataSource = data;
        setImgDataSource(data);
    }
    const onImgPaginationChange = (current: number, e?: any) => {
        let result = imgDataSource.data.slice((current - 1) * imgPageSize, current * imgPageSize);
        if (result.length > 0) {
            setImgDataSourceEx({ ...imgDataSource, dataSource: result, currentPage: current });
        } else {
            if (current !== 1) {
                current = current - 1;
                let _result = imgDataSource.data.slice((current - 1) * imgPageSize, current * imgPageSize);
                setImgDataSourceEx({ ...imgDataSource, dataSource: _result, currentPage: current });
            } else {
                setImgDataSourceEx({ ...imgDataSource, dataSource: result, currentPage: 1 });
            }
        }

    }

    const onTabChange = async (key: any) => {
        setCurrenttab(key);
        if (key == '3') {

            try {
                if (key == 3 && !imgDataSetIdRef.current) {
                    sGlobal.showloading = true;
                    sGlobal.showLoadingEvent.emit();
                    let data = { chunkId: imgDescData.chunkId, content: imgDescData.content };
                    const response = await axios.get(
                        sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/picture`,
                        { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
                    ).then(response => {
                        if (response.data.code.toString() === '0') {
                            // setVisible({ ...visible, imgEdit: false });
                            // messageService.showMessage({ mes: `修改<${imgDescData.id}>描述成功` });

                            SetUploadImgUrl(sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${response.data.Data.Id}/documents?chunkingmethod=picture&type=${type}&typeid=${typeId}`)
                            imgDataSetIdRef.current = response.data.Data.Id;
                            getImgList();
                        }
                        else {
                            throw JSON.stringify(response.data);
                        }
                    }).catch(error => {
                        throw error;
                    });

                }



            } catch (error) {
                messageService.showMessage(messageService.handleErr(error, "图片知识库获取"));
            } finally {
                sGlobal.showloading = false;
                sGlobal.closeLoadingEvent.emit();
            }
        }


    }
    const getImgList = async (page: any = null) => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            const response = await axios.get(
                sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${imgDataSetIdRef.current}/documents?chunkingmethod=picture`,
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            );
            if (response.data.code !== 0 && response.data.code !== '0') {
                throw JSON.stringify(response.data);
            }
            else {
                let data = [] as any;
                if (response.data.Data)
                    data = response.data.Data
                imgDataSource.data = data;
                let _page = imgDataSource.currentPage;
                if (page)
                    _page = page;
                setImgDataSourceEx({ ...imgDataSource, data: data, selectedRowKeys: [], selectRecords: [], currentPage: _page });
                onImgPaginationChange(_page);
                //SetUploadUrl(sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${datas.Id}/documents`)

            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "知识库图片列表获取"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }

    }
    const refreshImg = (page: any) => {
        getImgList(page)
    }
    const imgEdit = async (id: any) => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            const response = await axios.get(
                sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${imgDataSetIdRef.current}/documents/${id}/chunks`,
                { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
            );
            if (response.data.code !== 0 && response.data.code !== '0') {
                throw JSON.stringify(response.data);
            }
            else {
                if (response.data.Data.length > 0)
                    setImgDescData({ id: id, chunkId: response.data.Data[0].ChunkId, content: response.data.Data[0].Content });
                else
                    setImgDescData({ id: id, chunkId: '', content: '' });
                setVisible({ ...visible, imgEdit: true });

            }
        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "图片获取"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const imgDelete = (id: any) => {
        deleteData(id);
    }
    const imgEditOk = async () => {
        try {
            sGlobal.showloading = true;
            sGlobal.showLoadingEvent.emit();
            let data = { chunkId: imgDescData.chunkId, content: imgDescData.content };
            if (imgDescData.chunkId) {
                const response = await axios.put(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${imgDataSetIdRef.current}/documents/${imgDescData.id}/chunks`,
                    data,
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        setVisible({ ...visible, imgEdit: false });
                        messageService.showMessage({ mes: `修改<${imgDescData.id}>描述成功` });
                    }
                    else {
                        throw JSON.stringify(response.data);
                    }
                }).catch(error => {
                    throw error;
                });
            } else {
                const response = await axios.post(
                    sGlobal.config.host + `/api/${sGlobal.currentAppId}/rag/datasets/${imgDataSetIdRef.current}/documents/${imgDescData.id}/chunks`,
                    { content: data.content },
                    { headers: { 'Authorization': `Bearer ${sGlobal.session.id}` } }
                ).then(response => {
                    if (response.data.code.toString() === '0') {
                        setVisible({ ...visible, imgEdit: false });
                        messageService.showMessage({ mes: `修改<${imgDescData.id}>描述成功` });
                    }
                    else {
                        throw JSON.stringify(response.data);
                    }
                }).catch(error => {
                    throw error;
                });
            }


        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "图片描述修改"));
        } finally {
            sGlobal.showloading = false;
            sGlobal.closeLoadingEvent.emit();
        }
    }
    const openImgDialog = () => {
        setImgUploadValues([]);
        setVisibleEx({ ...visible, uploadImg: true });

    }

    useEffect(() => {
        fieldRef.current.reset();
        if (datas) {
            imgDataSetIdRef.current = null;
            setImgDataSourceEx({
                data: [] as any[], dataSource: [] as any[], currentPage: 1, selectedRowKeys: [], selectRecords: []
            });
            setCurrenttab('1');
            fieldRef.current.setValues(datas);
            if (datas.Config) {
                fieldRef.current.setValue("Config", JSON.stringify(datas.Config));
            }
        }
        refresh();
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                const { width, height } = entry.contentRect;
                //   console.log('Element size changed:', width, height);
                let _height = height;
                if (height > 0) {
                    let diff = _height - 92.45;
                    if (diff > 0) {
                        if (divHeight !== diff.toString() + 'px')
                            setDivHeight(diff.toString() + 'px');
                    }

                    else
                        setDivHeight('232px');
                }

            }
        });

        if (perRef.current) {
            resizeObserver.observe(perRef.current);
        }

        return () => {
            if (perRef.current) {
                resizeObserver.unobserve(perRef.current);
            }
        };
    }, [datas]);
    return (
        <>
            <div className=" bef-data-manager bef-user bef-user-section padding-24 gap-24-i" style={{ position: 'relative', padding: '0' }}>
                <div className="bef-user-header" style={{ display: 'flex', flexDirection: 'row', gap: 24, height: 'auto', padding: '16px', background: '#ffffff', borderRadius: '5px' }}>
                    {/* <Button style={{ color: '#e41f07', background: 'transparent', border: 'none', padding: '0', fontSize: '14px' }} onClick={() => { pageService.close() }}> <Icon type="arrow-left" /></Button> */}
                    <span className="bef-user-title" style={{ flex: 1 }}>知识库管理</span>
                    <div className="bef-user-btngroup justify-end">
                        <Button className="custom-btn " type="normal" size="medium" onClick={onDelete}
                            style={{ color: '#ffffff', backgroundColor: 'rgb(255, 56, 60)', borderColor: 'rgb(255, 56, 60)' }} >
                            <MixIcon value="1:trash" size="xs" />删除</Button>
                    </div>

                </div>
                {/* <div className='custom-card padding-16 flex-1 display-flex-col'> */}
                <div className="tab-div" style={{ overflow: 'hidden' }}>
                    <Tab onChange={onTabChange} activeKey={currentTab} >
                        <Tab.Item title="知识库文档" key="1">
                            <div className="tab-item">
                                <div className="bef-user-btngroup justify-end">

                                    <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium" onClick={() => { setUploadValues([]); setVisibleEx({ ...visible, upload: true }); }}><MixIcon value="1:arrowUpSharp" size="xs" />上传</Button>


                                    <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#3B5998', borderColor: '#3B5998' }} type="normal" size="medium" onClick={refresh}><MixIcon value="1:reload" size="xs" />刷新</Button>
                                    <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#0cc763', borderColor: '#0cc763' }} type="normal" size="medium" onClick={analysisData}><MixIcon value="1:bulbOutline" size="xs" />解析</Button>

                                </div>
                                <div className="flex-1 margin-top-16 custom-table display-flex-col  " ref={perRef} style={{ overflow: 'hidden' }}>

                                    <Table.StickyLock style={{ height: '100%' }} className="bef-user-content bef-data-manager flex-1" fixedHeader size='medium' maxBodyHeight={divHeight} primaryKey="Id" dataSource={dataSource?.dataSource} hasBorder={false}
                                        rowSelection={{ selectedRowKeys: dataSource.selectedRowKeys, onChange: (selectedKeys, records) => setDataSourceEx({ ...dataSource, selectedRowKeys: selectedKeys, selectRecords: records }) }}
                                        onResizeChange={(dataIndex: string, value: number) => {
                                            let newData = { ...dataSource.columnWidth };
                                            newData[dataIndex] = (newData[dataIndex] ?? 0) + value;
                                            setDataSourceEx({ ...dataSource, columnWidth: newData });
                                        }}>
                                        <Table.Column asyncResizable title="操作" lock='left' dataIndex="Id" cell={actionCellRender} width={274} />
                                        <Table.Column asyncResizable title="解析状态" dataIndex="Run" width={dataSource.columnWidth.Run} cell={runStatus} />
                                        <Table.Column asyncResizable title="状态" dataIndex="Status" width={dataSource.columnWidth.Status} cell={changeStatus} />
                                        <Table.Column asyncResizable title="编号" dataIndex="Id" width={dataSource.columnWidth.Id} />
                                        <Table.Column asyncResizable title="名称" dataIndex="Name" width={dataSource.columnWidth.Name} />
                                        <Table.Column asyncResizable title="位置" dataIndex="Location" width={dataSource.columnWidth.Location} />

                                        <Table.Column asyncResizable title="Chunk Method" dataIndex="ChunkMethod" width={dataSource.columnWidth.ChunkMethod} />
                                        <Table.Column asyncResizable title="Chunk Count" dataIndex="chunk_count" width={dataSource.columnWidth.chunk_count} />
                                        <Table.Column asyncResizable title="Process Duation" dataIndex="ProcessDuation" width={dataSource.columnWidth.ProcessDuation} />
                                        {/* <Table.Column asyncResizable title="Process" dataIndex="Process" width={dataSource.columnWidth.Process} /> */}
                                        <Table.Column asyncResizable title="类型" dataIndex="Type" width={dataSource.columnWidth.Type} />

                                        <Table.Column asyncResizable title="创建日期" dataIndex="CreateDate" width={dataSource.columnWidth.CreateDate} cell={(value, index, record) => value ? new Intl.DateTimeFormat('zh-CN').format(new Date(value)) : ''} />

                                        <Table.Column asyncResizable title="更新日期" dataIndex="UpdateDate" width={dataSource.columnWidth.UpdateDate} cell={(value, index, record) => value ? new Intl.DateTimeFormat('zh-CN').format(new Date(value)) : ''} />

                                    </Table.StickyLock>

                                    <div className="display-flex justify-end margin-top-8 margin-bottom-8 margin-right-6">
                                        <Pagination shape="no-border" pageSize={pageSize} total={dataSource.data.length} current={dataSource.currentPage} onChange={onPaginationChange} />
                                    </div>
                                </div>
                            </div>
                        </Tab.Item>
                        <Tab.Item title="知识库详情" key="2">
                            <div className="tab-item">
                                <div className="bef-user-btngroup justify-end">
                                    <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#0c9cfc', borderColor: '#0c9cfc' }} type="normal" size="medium" onClick={onSave} ><MixIcon value="1:save" size="xs" />保存</Button>
                                </div>
                                <div className="detail">
                                    <Form field={fieldRef.current} className="bef-custom-dep">
                                        <Grid.Row gutter="12">
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" required label="编号" name="Id">
                                                    <Input disabled />
                                                </Form.Item>

                                            </Grid.Col>
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="名称" name="Name">
                                                    <Input disabled />
                                                </Form.Item>
                                            </Grid.Col>
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="描述" name="Description">
                                                    <Input />
                                                </Form.Item>
                                            </Grid.Col>

                                        </Grid.Row>
                                        <Grid.Row gutter="12">
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="Embedding Model" name="EmbeddingModel">
                                                    <Input disabled />
                                                </Form.Item>

                                            </Grid.Col>
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="Chunk Method" name="ChunkMethod">
                                                    <Input disabled />
                                                </Form.Item>
                                            </Grid.Col>
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="Config" name="Config">
                                                    <Input disabled />
                                                </Form.Item>
                                            </Grid.Col>

                                        </Grid.Row>
                                        <Grid.Row gutter="12">
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="创建日期" name="CreateDate">
                                                    {/* <Input disabled /> */}
                                                    <DatePicker disabled style={{ width: '100%' }} />
                                                </Form.Item>

                                            </Grid.Col>
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="创建用户" name="CreateUser">
                                                    <Input disabled />
                                                </Form.Item>
                                            </Grid.Col>
                                            <Grid.Col>
                                                <Form.Item className="custom-form-control" label="更新日期" name="UpdateDate" >
                                                    {/* <Input disabled /> */}
                                                    <DatePicker disabled style={{ width: '100%' }} />
                                                </Form.Item>
                                            </Grid.Col>

                                        </Grid.Row>
                                    </Form>
                                </div>
                            </div>
                        </Tab.Item>
                        <Tab.Item title="知识库图片" key="3">
                            <div className="tab-item">
                                <div className="bef-user-btngroup justify-end">
                                    <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium"
                                        onClick={openImgDialog}><MixIcon value="1:arrowUpSharp" size="xs" />上传</Button>
                                    <Button className="custom-btn " style={{ color: '#ffffff', backgroundColor: '#3B5998', borderColor: '#3B5998' }} type="normal" size="medium" onClick={() => refreshImg(1)}><MixIcon value="1:reload" size="xs" />刷新</Button>
                                </div>
                                <div style={{ flex: '1', display: 'flex', flexWrap: 'wrap' }}>
                                    {imgDataSource.dataSource.map((item: any) => {
                                        return <>
                                            <div className="dataset-custom-card">
                                                <div>
                                                    <Button style={{ backgroundColor: "#e41f07", color: "#ffffff", border: 'none' }} onClick={() => imgDelete(item.Id)}> 删除</Button>
                                                    <Button onClick={() => imgEdit(item.Id)}> 编辑</Button>
                                                </div>
                                                <img src={`/api/${sGlobal.currentAppId}/rag/datasets/${imgDataSetIdRef.current}/documents/${item.Id}`} />
                                                <p title={item.Id}>{item.Id}</p>
                                                <p title={item.Name}>{item.Name}</p>
                                            </div>
                                        </>
                                    })}
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '8px 6px' }}>
                                    <Pagination shape="arrow-only" defaultCurrent={1} pageSize={imgPageSize} current={imgDataSource.currentPage} total={imgDataSource.data.length} onChange={onImgPaginationChange} />

                                </div>
                            </div>
                        </Tab.Item>
                    </Tab>
                </div>





            </div>
            {/* </div> */}
            <Dialog v2 title="文件上传" width={800} visible={visible.upload} footer={[]}
                onClose={onOK}>
                <div className="bef-data-manager">
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Upload
                            action={uploadUrl}
                            onChange={onUploadChange}
                            onSuccess={onUploadSuccess}
                            webkitdirectory
                            value={uploadValues}
                            headers={header}
                            onError={onUploadError}
                            formatter={formatRes}
                        >
                            <Button className="custom-btn" style={{ marginBottom: '16px', color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium" ><MixIcon value="1:arrowUpSharp" size="xs" />上传文件夹</Button>

                        </Upload>
                        <Upload
                            action={uploadUrl}
                            onChange={onUploadChange}
                            onSuccess={onUploadSuccess}
                            value={uploadValues}
                            multiple
                            headers={header}
                            onError={onUploadError}
                            formatter={formatRes}
                        >
                            <Button className="custom-btn" style={{ marginBottom: '16px', color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium" ><MixIcon value="1:arrowUpSharp" size="xs" />上传文件</Button>

                        </Upload>
                    </div>
                    <div style={{ height: 400, overflow: 'auto', }}>
                        <Upload
                            listType="text"
                            value={uploadValues}
                        >
                        </Upload>
                    </div>


                </div>
            </Dialog>
            <Dialog v2 title="图片上传" width={800} visible={visible.uploadImg} footerActions={['cancel', 'ok']}
                okProps={{ className: 'custom-dialog-btn-ok', children: "上传" }} cancelProps={{ className: 'custom-dialog-btn-cancel', children: "关闭" }}
                onClose={() => {
                    getImgList();
                    //refresh();
                    setVisibleEx({ ...visible, uploadImg: false })
                }} onOk={imgUploadOk}>
                <div className="bef-data-manager upload">
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Upload
                            action={uploadImgUrl}
                            onChange={onImgUploadChange}
                            onSuccess={onUploadSuccess}
                            webkitdirectory
                            value={imgUploadValues}
                            headers={header}
                            onError={onUploadError}
                            autoUpload={false}
                            accept="image/*"
                            beforeUpload={beforeImgUpload}
                            formatter={formatRes}
                            data={exdata}
                        >
                            <Button className="custom-btn" style={{ marginBottom: '16px', color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium"><MixIcon value="1:arrowUpSharp" size="xs" />选择文件夹</Button>

                        </Upload>
                        <Upload
                            action={uploadImgUrl}
                            onChange={onImgUploadChange}
                            onSuccess={onUploadSuccess}
                            value={imgUploadValues}
                            multiple
                            headers={header}
                            onError={onUploadError}
                            autoUpload={false}
                            ref={fileRef}
                            accept="image/*"
                            beforeUpload={beforeImgUpload}
                            formatter={formatRes}
                            data={exdata}
                        >
                            <Button className="custom-btn" style={{ marginBottom: '16px', color: '#ffffff', backgroundColor: 'rgb(12, 156, 252)', borderColor: 'rgb(12, 156, 252)' }} type="normal" size="medium"><MixIcon value="1:arrowUpSharp" size="xs" />选择文件</Button>

                        </Upload>
                    </div>
                    <div style={{ height: 400, overflow: 'auto', }}>
                        <Upload
                            listType="image"
                            value={imgUploadValues}
                            actionRender={actionRender}
                        >
                        </Upload>
                    </div>


                </div>
            </Dialog>
            <Dialog v2 title="图片描述编辑" width={800} visible={visible.imgEdit} footerActions={['cancel', 'ok']}
                okProps={{ className: 'custom-dialog-btn-ok', children: "确定" }} cancelProps={{ className: 'custom-dialog-btn-cancel' }}
                onClose={() => setVisibleEx({ ...visible, imgEdit: false })} onOk={imgEditOk}>
                <div className="bef-data-manager dialog ">
                    <div style={{ height: 400 }}>
                        <div className="row">
                            <div className="custom-form-control" style={{ flex: 1 }} >
                                <label>Id</label>
                                <Input defaultValue={imgDescData.id} disabled style={{ width: '100%' }} />
                            </div>
                            <div className="custom-form-control" style={{ flex: 1 }} >
                                <label>chunkId</label>
                                <Input defaultValue={imgDescData.chunkId} disabled style={{ width: '100%' }} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="custom-form-control" style={{ flex: 1 }}>
                                <label>图片</label>
                                <img src={`/api/${sGlobal.currentAppId}/rag/datasets/${fieldRef.current.getValue('Id')}/documents/${imgDescData.id}`} style={{ width: '100%', padding: '0', height: '200px', objectFit: 'contain' }} />
                            </div>
                            <div className="custom-form-control" style={{ flex: 1 }}></div>

                        </div>
                        <div className="row">
                            <div className="custom-form-control" style={{ flex: 1 }}>
                                <label>描述</label>
                                <Input.TextArea rows={8} value={imgDescData.content} style={{ width: '100%' }} onChange={val => setImgDescData({ ...imgDescData, content: val })} />

                            </div>
                        </div>
                    </div>


                </div>
            </Dialog>
        </>

    );
});
export default DataSetManager;